import { createApiClient } from '@wl/ui';

/** Oturum düştüğünde AuthProvider dinler (giriş ekranına döner). */
export const sessionEvents = new EventTarget();

export const api = createApiClient({
  refreshPath: '/auth/refresh',
  onSessionExpired: () => sessionEvents.dispatchEvent(new Event('expired')),
});
